import { api } from './api-base';
import { User } from '../types';

// Auth API
export const authApi = {
  // Get current user (optional backend route)
  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  // Set username (nickname) for the authenticated user (one-time only)
  setUsername: async (username: string): Promise<User> => {
    const response = await api.post('/auth/username', { username });
    return response.data;
  },
  // Record Terms acceptance for current authenticated user
  acceptTerms: async (version = 'v1'): Promise<{ id: string; termsAcceptedAt: string; termsVersion: string }> => {
    const response = await api.post('/auth/terms/accept', { version });
    return response.data;
  },
  // Check username availability
  checkUsername: async (u: string): Promise<{ available: boolean; reason?: string }> => {
    const response = await api.get('/auth/username/available', { params: { u } });
    return response.data;
  },
  // Check if email is already registered
  checkEmail: async (email: string): Promise<{ exists: boolean; source?: string; blocked?: boolean; blockedUntil?: string; reason?: string }> => {
    const response = await api.get('/auth/email/exists', { params: { email } });
    return response.data;
  },
  // Delete current user's account (from both Supabase and Neon)
  deleteAccount: async (): Promise<{ deleted: boolean }> => {
    const response = await api.delete('/auth/me');
    return response.data;
  },
};
